export const styles = {
  image: {
    objectFit: 'cover',
    width: '100%',
    height: '100%',
  },
};
